var _path, _line, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24516 4.67832C1.11852 4.0584 1.5922 3.47818 2.22493 3.47818H17.7751C18.4078 3.47818 18.8815 4.0584 18.7548 4.67832L15.7884 19.2001C15.6933 19.6657 15.2838 20 14.8086 20H5.19138C4.71624 20 4.3067 19.6657 4.21161 19.2001L1.24516 4.67832Z",
    stroke: "#0058A9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.1091,
    y1: 6.23207,
    x2: 10.1091,
    y2: 17.2466,
    stroke: "#0058A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30466 6.23207L6.86987 17.2466",
    stroke: "#0058A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6958 6.23207L13.1306 17.2466",
    stroke: "#0058A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26514 2C5.26514 1.44772 5.71285 1 6.26514 1H12.8738C13.4261 1 13.8738 1.44772 13.8738 2V3.47827H5.26514V2Z",
    stroke: "#0058A9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.bfd351b27cbbee0668d52d8be448ea3e.svg";
export { ForwardRef as ReactComponent };